import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'htmlToPlaintext'
})
export class HtmlToPlaintextPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    // Decode HTML entities (like &amp; to &)
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    const decoded = textarea.value;

    // Strip HTML tags
    const div = document.createElement('div');
    div.innerHTML = decoded;
    return div.textContent || div.innerText || '';
  }
}